import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, EASE } from "@/lib/motion";
import { PAIN_VS_FIX } from "@/data/site";

export const PainVsFix = () => {
  const [mode, setMode] = useState("fix"); // "challenge" | "fix"
  const isFix = mode === "fix";

  return (
    <section data-testid="pain-vs-fix" className="section-pad bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-[#999999] mb-6 font-mono">The Gap</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-4xl text-[#111111]">
            The Gap Between Content and Growth.
          </h2>
          <p className="mt-6 max-w-2xl text-lg md:text-xl text-[#666666] leading-relaxed">
            This is how we close it.
          </p>
        </Reveal>

        {/* Toggle */}
        <Reveal delay={0.1}>
          <div className="mt-12 inline-flex border border-[#111111] p-1 bg-white" data-testid="pvf-toggle">
            {[
              ["challenge", "The Challenge"],
              ["fix", "The Fix"],
            ].map(([m, label]) => (
              <button
                key={m}
                data-testid={`pvf-toggle-${m}`}
                onClick={() => setMode(m)}
                className={`relative px-6 md:px-10 py-3 text-sm font-semibold uppercase tracking-[0.15em] transition-colors ${
                  mode === m ? "text-white" : "text-[#111111] hover:text-[#666666]"
                }`}
              >
                {mode === m && (
                  <motion.span
                    layoutId="pvf-pill"
                    className="absolute inset-0 bg-[#111111]"
                    transition={{ type: "spring", stiffness: 400, damping: 34 }}
                  />
                )}
                <span className="relative z-10">{label}</span>
              </button>
            ))}
          </div>
        </Reveal>

        {/* Panel */}
        <motion.div
          animate={{ backgroundColor: isFix ? "#111111" : "#F5F5F5" }}
          transition={{ duration: 0.5, ease: EASE }}
          className="mt-8 border border-[#E0E0E0]"
          data-testid="pvf-panel"
        >
          <div className="grid grid-cols-1 md:grid-cols-2">
            {PAIN_VS_FIX.map((row, i) => (
              <div
                key={row.point}
                className={`p-8 md:p-10 border-[#E0E0E0] ${i % 2 === 0 ? "md:border-r" : ""} ${
                  i < PAIN_VS_FIX.length - (PAIN_VS_FIX.length % 2 === 0 ? 2 : 1) ? "border-b" : ""
                }`}
                style={{ borderColor: isFix ? "#333333" : "#E0E0E0" }}
              >
                <div className="flex items-baseline gap-4">
                  <span
                    className="font-mono text-xs"
                    style={{ color: isFix ? "#666666" : "#999999" }}
                  >
                    0{i + 1}
                  </span>
                  <h3
                    className="font-serif text-2xl md:text-3xl"
                    style={{ color: isFix ? "#FFFFFF" : "#111111" }}
                  >
                    {row.point}
                  </h3>
                </div>
                <AnimatePresence mode="wait">
                  <motion.p
                    key={mode + i}
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -12 }}
                    transition={{ duration: 0.35, ease: EASE }}
                    className="mt-4 text-base md:text-lg leading-relaxed pl-8"
                    style={{ color: isFix ? "#E0E0E0" : "#666666" }}
                  >
                    {isFix ? row.fix : row.challenge}
                  </motion.p>
                </AnimatePresence>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
